<script lang="ts">
  import Icon from '../../../assets/svgs/icon.svelte';

  export let icon: string;
  export let color: string = '#FF1A66';
  export let width: number = 40;
  export let height: number = 40;
</script>

<Icon {icon} {color} {width} {height} />
